// Antd
import { Pagination, Table, PaginationProps } from 'antd'
import { ColumnsType } from './interface'
import type { ColumnsType as Type } from 'antd/es/table'
import styles from './styles.module.scss'
// helpers
import max from 'lodash/max'
import get from 'lodash/get'
import cells from './Cells'
import SpinnerLogo from 'media/SpinerLogo'
import CommonCell from './Cells/CommonCell'
import NoData from './NoData'

interface TableInterface {
  columns: ColumnsType<any>
  data: any[]
  rows?: number
  page?: number
  setPage?: (val: number) => void
  total?: number
  loading?: boolean
  emptyData?: boolean
  rowClassName?: (record, rowIndex) => string
  onRow?: (record, rowIndex) => any
}

const itemRender: PaginationProps['itemRender'] = (
  _,
  type,
  originalElement
) => {
  if (['prev', 'next'].includes(type)) {
    return originalElement
  }
  console.log(originalElement, _)

  return originalElement
}

const TableComponent: React.FC<TableInterface> = ({
  columns: rawColumns,
  data = [],
  rows = 7,
  page = 1,
  loading = false,
  total = 1,
  setPage,
  rowClassName = undefined,
  onRow = undefined
}) => {
  const emptyRows = Array.from({
    length: max([0, rows - data.length])
  }).map((_, i) => ({ key: `empty-row-${i}` }))
  const columns = rawColumns.map(({ type, ...props }, i) => {
    if (!type)
      return { render: CommonCell, ...props, key: `${props.dataIndex}-${i}` }

    return {
      render: get(cells, type, undefined),
      key: props.dataIndex,
      ...props
    }
  })

  const onChange: PaginationProps['onChange'] = newPage => {
    setPage(newPage)
  }

  return (
    <div>
      <Table
        rowClassName={rowClassName}
        onRow={onRow}
        loading={{
          indicator:
            data.length === 0 && !loading ? (
              <div
                style={{
                  transformOrigin: 'center center',
                  transform: 'scale(0.4)',
                  top: 'calc(50% - 60px)',
                  left: 'calc(50% - 146px - 10rem)',
                  width: '41rem',
                  textAlign: 'center'
                }}
              >
                <NoData />
                <span
                  style={{
                    width: '41rem',
                    color: '#454545',
                    textAlign: 'center',
                    fontSize: '2rem'
                  }}
                >
                  No se encontraron datos
                </span>
              </div>
            ) : (
              <SpinnerLogo
                style={{
                  top: '50%',
                  left: 'calc(50% - 50px)'
                }}
              />
            ),
          spinning: loading || (data.length === 0 && !loading)
        }}
        columns={columns as Type}
        dataSource={[...data, ...emptyRows]}
        className={styles.tableComponent}
        pagination={false}
      />
      <Pagination
        className={styles.tablePagination}
        onChange={onChange}
        current={page}
        pageSize={rows}
        total={total}
        showSizeChanger={false}
      />
    </div>
  )
}

export default TableComponent
